import produce, { castDraft, } from 'immer';
import { MetricsReportSubscriptionsActionType, } from './actions';
const subscriptionsByIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case MetricsReportSubscriptionsActionType.SET_SUBSCRIPTIONS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const { subscriptions } = actualAction;
                // Add or replace subscriptions in subscriptionsById with the new list of subscriptions
                subscriptions.items.forEach((subscription) => {
                    draft[subscription.id] = subscription;
                });
            });
        case MetricsReportSubscriptionsActionType.SET_SUBSCRIPTION:
            // When a subscription is updated, we need to update the associated subscription in the map of subscriptionsById
            return produce(currentState, (draft) => {
                const actualAction = action;
                draft[actualAction.subscription.id] = actualAction.subscription;
            });
        default:
            return currentState;
    }
};
const subscriptionIdsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case MetricsReportSubscriptionsActionType.SET_SUBSCRIPTIONS:
            return produce(currentState, (draft) => {
                // actualAction.subscriptions contains the complete MetricsReportSubscription object. However, we only need to save the
                // list of subscription IDs in draft[actualAction.searchParams]
                const actualAction = action;
                draft[actualAction.searchParams] = {
                    range: actualAction.subscriptions.range,
                    // convert array of Subscription objects to array of subscription Id.
                    items: actualAction.subscriptions.items.map((sub) => {
                        return sub.id;
                    }),
                };
            });
        case MetricsReportSubscriptionsActionType.CLEAR_SUBSCRIPTIONS:
            // To clear subscription ids, we just need to set 'subscriptionIds' to a new object
            return produce(currentState, () => {
                return {};
            });
        default:
            return currentState;
    }
};
export const metricsReportSubscriptionsStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.subscriptionsById = subscriptionsByIdReducer(currentState.subscriptionsById, action);
        draft.subscriptionIds = castDraft(subscriptionIdsReducer(currentState.subscriptionIds, action));
    });
};
